import styled from 'styled-components';
// import {View} from 'react-native';

export const _MenuNavigationRoot = styled('div')<{}>(() => ({
  borderRadius: '8px',
  background: 'rgba(17, 18, 22, 0.50)',
  boxShadow: '2px 2px 10px 0px rgba(0, 0, 0, 0.10)',
  backdropFilter: 'blur(10px)',
  display: 'inline-flex',
  padding: '16px 32px',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '48px',

  '@media (max-width: 1300px)': {
    gap: '3%', 
    padding: '1% 3%',
  },
}));
